import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  type ChartData,
  type ChartOptions,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export interface LineChartProps {
  data: ChartData<'line'>;
}

const LineChart: React.FC<LineChartProps> = ({ data }) => {
  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 20,
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: '#165BAA',
        titleColor: '#fff',
        bodyColor: '#fff',
        displayColors: false,

        callbacks: {
          title: () => [],
          label: (context) => {
            const y = context.parsed.y;
            return y != null ? `Value: ${y.toFixed(1)}` : 'Value: N/A';
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
    elements: {
      line: {
        borderColor: '#165BAA',
        borderWidth: 3,
        tension: 0.4,
        cubicInterpolationMode: 'monotone',
      },
      point: {
        radius: 0,
        hitRadius: 10,
        hoverRadius: 4,
        hoverBackgroundColor: '#165BAA',
      },
    },
    scales: {
      x: { display: false },
      y: { display: false },
    },
    animation: {
      duration: 1200,
      easing: 'easeOutQuart',
    },
  };

  return (
    <Line
      data={data}
      options={options}
      style={{ height: '100%', width: '100%' }}
    />
  );
};

export { LineChart };
